export default __webpack_public_path__ + "images/5144f620958f58962a0b55ff06f38d2a.svg";